<template>
  <div class="login-container">
    <el-form
      autoComplete="on"
      :model="loginForm"
      size="default"
      :rules="loginRules"
      ref="loginForm"
      class="card-box login-form"
    >
      <h3 class="title">{{ $store.state.sys.title }}</h3>


      <el-form-item prop="username">

        <el-input
          name="username"
          type="text"
          v-model.trim="loginForm.username"
          autoComplete="on"
          placeholder="登录用户名"
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          name="password"
          :type="pwdType"
          @keyup.enter.native="handleLogin"
          v-model="loginForm.password"
          autoComplete="on"
          placeholder="登录密码"
        ></el-input>
      </el-form-item>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="" prop="shopid">
            <el-input placeholder="请输入验证码" v-model="code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <div class="login-code" style="cursor: pointer" @click="refreshCode">
            <s-identify :identifyCode="identifyCode"></s-identify>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
            <el-form-item>
                <el-button
                  type="primary"
                  style="width:100%"
                  :loading="loading"
                  @click.native.prevent="handleLogin">
                  登录
                </el-button>        
          </el-form-item>
        </el-col>
        <el-col :span="8">
                <el-form-item>
                  <el-button
                    type="primary"
                    style="width:100%"
                     @click.native.prevent="forgetpwd">                   
                    忘记密码
                  </el-button>        
          </el-form-item>
        </el-col>
         <el-col :span="8">
                <el-form-item>
                  <el-button
                    type="primary"
                    style="width:100%"
                     @click.native.prevent="refreshpage">                   
                    重置
                  </el-button>        
          </el-form-item>
        </el-col>
      </el-row>
   
      <div class="tips">
        Copyright © {{ new Date().getFullYear() }}
        {{ $store.state.sys.company }}      
      </div>
      <div class="tips">
          {{ $store.state.sys.info }}
      </div>
    </el-form>
  </div>
</template>

<script>
import sysConfigApi from "@/api/sys/config";
import SIdentify from "../components/SIdentity.vue";
export default {
  inject:['reload'],
  name: "login",
  components: { SIdentify },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入用户名" },
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
      loading: false,
      pwdType: "password",
      identifyCode: "",
      identifyCodes: "1234567890",
      code: "",
    };
  },

  created() {
    // sysConfigApi.getValue('login').then(res=>{
    //   let remoteVersion = res.data
    //   if(remoteVersion !==this.$refs.version.innerText){
    //     this.$confirm('检测本地系统版本与服务器系统版本不一致，是否进行刷新加载更新内容？','更新提示',{
    //       type:'warning',
    //       confirmButtonText: '刷新',
    //     }).then(()=>{
    //       // this.$store.
    //       // window.location.reload()
    //     })
    //   }
    // })
    let that = this;
    document.onkeydown =function(e){
      e = window.event || e;
      if(that.$route.path=='/login'&&(e.code=='Enter'||e.code=='enter')){//验证在登录界面和按得键是回车键enter
       // that.submitForm('loginForm');//登录函数
       console.log('触发默认提交罗'+Math.random());
       that.handleLogin();
      }
    }

  },
  methods: {
    checkLogin() {
      configApi.getValue("login").then((res) => {
        if (res.data === "off") {
          this.isLogin = false;
        }
      });
    },
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    forgetpwd(){
       this.$router.push('/forgetPassword');
    },
    refreshpage(){
      //  this.$router.push('/login?'+Math.random());
      // location.reload();
      this.reload();
    },
    handleLogin() {
      if (this.identifyCode !== this.code) {
        this.code = "";
        this.refreshCode();
        this.$message.error({
          showClose: true,
          message: "请输入正确的验证码",
          duration: 2000,
        });
      } else {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$store
              .dispatch("login", this.loginForm)
              .then((res) => {
                //this.loading = false
                this.$router.push({ path: "/" });
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
      // console.log(this.identifyCode);
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  },

  mounted() {
    this.refreshCode();
  },
};
</script>

<style lang="less">
@bg: #2d3a4b;
@dark_gray: #889aa4;
@light_gray: #eee;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: @bg;
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
  }
  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: @light_gray;
    height: 47px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
  }
  .tips {
    font-size: 14px;
    color: @light_gray;
    margin-bottom: 10px;
    text-align: center;
  }
  .yzmtext {
    font-size: 14px;
    color: @light_gray;
  height: 46px;
    text-align: left;
    vertical-align:middle;
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: @dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: @light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    max-width: 400px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
    margin-bottom: 22px;
  }
  .el-form-item__error {
    padding-top: 4px;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: @dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }
}
</style>
